export default {
  path: 'employee',
  component: () => import('@/views/Route'),
  children: [
    {
      path: 'add-employee',
      name: 'Add Employee',
      component: () => import('@/views/menus/employee/AddEmployee'),
      meta: {
        permission: true
      }
    },
    {
      path: 'employee-attendance',
      name: 'Employee Attendance',
      component: () => import('@/views/menus/employee/Attendance/EmployeeAttendance'),
      meta: {
        permission: true
      }
    },
    {
      path: 'employee-attendance-recap',
      name: 'Recap Attendance',
      component: () => import('@/views/menus/employee/RecapAttendance'),
      meta: {
        permission: true
      }
    },
    {
      path: 'employee-statistic-attendance',
      name: 'Statistic Attendance',
      component: () => import('@/views/menus/employee/StatisticAttendanceEmployees'),
      meta: {
        permission: true
      }
    },
    {
      path: 'employee-kpi/:id',
      name: 'Key Perfomance Indicator',
      component: () => import('@/views/menus/employee/keyPerformanceIndicator/Index'),
      meta: {
        permission: true
      }
    },
    {
      path: 'edit-profile',
      name: 'Edit Profile',
      component: () => import('@/views/profileEmployee/EditProfile'),
      meta: {
        permission: true
      }
    },
    {
      path: ':id',
      name: 'Edit Employee',
      component: () => import('@/views/menus/employee/EditEmployee'),
      meta: {
        permission: true
      }
    }
  ]
}
